export const setGoods = (goods) =>({
    type: 'SET_PRODUCT',
    payload: goods
})